import moment from "moment";
import "moment/locale/ja";
import "moment/locale/de";
import "moment/locale/nl";

/**
 * Maps i18next language (e.g. en-US, ja-JP) to moment locale.
 * Matches PIIReports trade-in date column behavior.
 */
export function getMomentLocaleFromAppLanguage(lang) {
  const l = lang || "en-US";
  if (l.startsWith("ja")) return "ja";
  if (l.startsWith("de")) return "de";
  if (l.startsWith("nl")) return "nl";
  return "en";
}

/**
 * Formats a date for tables (Trade-In Date, etc.) using the active app language,
 * not moment's global locale (avoids "stuck" Japanese when UI is English).
 */
export function formatAppDateTime(date, lang, format = "MMM DD, YYYY, h:mm A") {
  if (!date) return "";
  const mLoc = getMomentLocaleFromAppLanguage(lang);
  return moment(date).locale(mLoc).format(format);
}
